const chartColors = {
  positive: "#10b981b3",
  negative: "#ef4444b3",
  blue: "#3b82f6b3",
  pink: "#ec4899b3",
  purple: "#8b5cf6b3",
  orange: "#f59e0bb3",
  teal: "#06b6d4b3",
  green: "#45F084b3",
};

export const chartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      labels: {
        color: "#e0e0e0",
      },
    },
  },
  scales: {
    y: {
      ticks: {
        color: "#e0e0e0",
      },
      grid: {
        color: "#444",
      },
    },
    x: {
      ticks: {
        color: "#e0e0e0",
      },
      grid: {
        color: "#444",
      },
    },
  },
  layout: {
    padding: {
      bottom: 15,
    },
  },
};

export const generateChartOzkaynaklar = (ozetRapor) => {
  if (!ozetRapor || !ozetRapor.bilanco) return null;

  const ozKaynaklar = ozetRapor.bilanco.anaOrtaklikOzKaynaklar
    .slice(0, 5)
    .map((item) => ({
      donem: `${item.year}/${item.month}`,
      value: item.value / 1000000000, // Milyar TL'ye çevirme
    }))
    .reverse();

  return {
    labels: ozKaynaklar.map((item) => item.donem),
    datasets: [
      {
        label: "Özkaynaklar (Milyar TL)",
        data: ozKaynaklar.map((item) => item.value),
        backgroundColor: ozKaynaklar.map((item) =>
          item.value >= 0 ? chartColors.blue : chartColors.negative
        ),
        borderColor: ozKaynaklar.map((item) =>
          item.value >= 0 ? chartColors.blue : chartColors.negative
        ),
        borderWidth: 1,
      },
    ],
  };
};

export const generateChartOdenmisSermaye = (ozetRapor) => {
  if (!ozetRapor || !ozetRapor.bilanco) return null;

  const odenmisSermaye = ozetRapor.bilanco.odenmisSermaye
    .slice(0, 5)
    .map((item) => ({
      donem: `${item.year}/${item.month}`,
      value: item.value / 1000000000, // Milyar TL'ye çevirme
    }))
    .reverse();

  return {
    labels: odenmisSermaye.map((item) => item.donem),
    datasets: [
      {
        label: "Ödenmiş Sermaye (Milyar TL)",
        data: odenmisSermaye.map((item) => item.value),
        backgroundColor: odenmisSermaye.map((item) =>
          item.value >= 0 ? chartColors.teal : chartColors.negative
        ),
        borderColor: odenmisSermaye.map((item) =>
          item.value >= 0 ? chartColors.teal : chartColors.negative
        ),
        borderWidth: 1,
      },
    ],
  };
};

export const generateChartSatisGelirleri = (ozetRapor) => {
  if (!ozetRapor || !ozetRapor.gelirTablosu) return null;

  const satislar = ozetRapor.gelirTablosu.satisGelirleri
    .slice(0, 5)
    .map((item) => ({
      donem: `${item.year}/${item.month}`,
      value: item.quarter_value / 1000000000, // Milyar TL'ye çevirme
    }))
    .reverse();

  return {
    labels: satislar.map((item) => item.donem),
    datasets: [
      {
        label: "Satış Gelirleri (Milyar TL)",
        data: satislar.map((item) => item.value),
        backgroundColor: satislar.map((item) =>
          item.value >= 0 ? chartColors.purple : chartColors.negative
        ),
        borderColor: satislar.map((item) =>
          item.value >= 0 ? chartColors.purple : chartColors.negative
        ),
        borderWidth: 1,
      },
    ],
  };
};

export const generateChartBrutKar = (ozetRapor) => {
  if (!ozetRapor || !ozetRapor.gelirTablosu) return null;

  const brutKar = ozetRapor.gelirTablosu.brutKar
    .slice(0, 5)
    .map((item) => ({
      donem: `${item.year}/${item.month}`,
      value: item.quarter_value / 1000000000, // Milyar TL'ye çevirme
    }))
    .reverse();

  return {
    labels: brutKar.map((item) => item.donem),
    datasets: [
      {
        label: "Brut Kar (Milyar TL)",
        data: brutKar.map((item) => item.value),
        backgroundColor: brutKar.map((item) =>
          item.value >= 0 ? chartColors.pink : chartColors.negative
        ),
        borderColor: brutKar.map((item) =>
          item.value >= 0 ? chartColors.pink : chartColors.negative
        ),
        borderWidth: 1,
      },
    ],
  };
};

export const generateChartDonemKari = (ozetRapor) => {
  if (!ozetRapor || !ozetRapor.gelirTablosu) return null;

  const donemKarlari = ozetRapor.gelirTablosu.donemKari
    .slice(0, 5)
    .map((item) => ({
      donem: `${item.year}/${item.month}`,
      value: item.quarter_value / 1000000000, // Milyar TL'ye çevirme
    }))
    .reverse();

  return {
    labels: donemKarlari.map((item) => item.donem),
    datasets: [
      {
        label: "Dönem Karı (Milyar TL)",
        data: donemKarlari.map((item) => item.value),
        backgroundColor: donemKarlari.map((item) =>
          item.value >= 0 ? chartColors.positive : chartColors.negative
        ),
        borderColor: donemKarlari.map((item) =>
          item.value >= 0 ? chartColors.positive : chartColors.negative
        ),
        borderWidth: 1,
      },
    ],
  };
};

export const generateChartFaaliyetKari = (ozetRapor) => {
  if (!ozetRapor || !ozetRapor.gelirTablosu) return null;

  const faaliyetKarlari = ozetRapor.gelirTablosu.faaliyetKari
    .slice(0, 5)
    .map((item) => ({
      donem: `${item.year}/${item.month}`,
      value: item.quarter_value / 1000000000, // Milyar TL'ye çevirme
    }))
    .reverse();

  return {
    labels: faaliyetKarlari.map((item) => item.donem),
    datasets: [
      {
        label: "Faaliyet Karı (Milyar TL)",
        data: faaliyetKarlari.map((item) => item.value),
        backgroundColor: faaliyetKarlari.map((item) =>
          item.value >= 0 ? chartColors.orange : chartColors.negative
        ),
        borderColor: faaliyetKarlari.map((item) =>
          item.value >= 0 ? chartColors.orange : chartColors.negative
        ),
        borderWidth: 1,
      },
    ],
  };
};
